import { Theme } from 'features/Theme';
import { css, SerializedStyles } from '@emotion/core';

const style = (theme: Theme): SerializedStyles =>
  css`
    .MuiSnackbarContent-message {
      ${theme.mui.typography.body2};
    }
  `;

export default style;
